componentRegistryInstance.register('pre', 'read', 'hrd.components.form.PreComponent');

hrd.components.form.PreComponent = hrd.components.AbstractFieldComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.PreComponent',
		};
		this._super($.extend(true, {}, defaults, options));
	},
	enhanceReadField: function(field, id, klass) {
		// avoid to used 'read-only-field'
		klass = 'pre-field';
		this._super(field, id, klass);
	},
});